(function(){
  const body=document.body;
  function money(cents){return (cents/100).toLocaleString('it-IT',{style:'currency',currency:'EUR',minimumFractionDigits:0})}
  async function refreshCart(){
    try{
      const r=await fetch('/cart.js'); const cart=await r.json();
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
      const drawer=document.querySelector('[data-cart-drawer-content]');
      if(!drawer)return;
      if(!cart.items.length){drawer.innerHTML='<div class="drawer-empty"><p>Il tuo carrello è vuoto</p></div>';return}
      drawer.innerHTML=cart.items.map(item=>`
        <div class="drawer-item">
          <img src="${item.image || ''}" alt="">
          <div>
            <div style="display:flex;justify-content:space-between;gap:8px"><h3>${item.product_title}</h3><button class="icon-btn" data-remove="${item.key}" aria-label="Rimuovi">×</button></div>
            ${item.variant_title && item.variant_title!=='Default Title'?`<p>${item.variant_title}</p>`:''}
            <div style="display:flex;align-items:center;justify-content:space-between;margin-top:12px">
              <div class="qty"><button data-qty="${item.key}" data-delta="-1">−</button><span>${item.quantity}</span><button data-qty="${item.key}" data-delta="1">+</button></div>
              <strong style="font-size:13px">${money(item.final_line_price)}</strong>
            </div>
          </div>
        </div>`).join('');
      document.querySelector('[data-cart-subtotal]').textContent=money(cart.total_price);
    }catch(e){}
  }
  async function addToCart(form){
    const data=new FormData(form);
    const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});
    if(r.ok){await refreshCart();openCart()} else alert('Non è stato possibile aggiungere il prodotto al carrello.');
  }
  function openCart(){body.classList.add('cart-open')}
  function closeCart(){body.classList.remove('cart-open')}
  document.addEventListener('click',async e=>{
    const open=e.target.closest('[data-open-cart]'), close=e.target.closest('[data-close-cart]');
    if(open){e.preventDefault();openCart();refreshCart()}
    if(close){e.preventDefault();closeCart()}
    const remove=e.target.closest('[data-remove]');
    if(remove){await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:remove.dataset.remove,quantity:0})});refreshCart()}
    const q=e.target.closest('[data-qty]');
    if(q){
      const key=q.dataset.qty;
      const drawerItem=q.closest('.drawer-item');
      const current=parseInt(drawerItem.querySelector('.qty span').textContent||'1',10);
      const next=Math.max(0,current+parseInt(q.dataset.delta,10));
      await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:next})});
      refreshCart();
    }
  });
  document.addEventListener('submit',e=>{
    const form=e.target.closest('[data-add-to-cart]');
    if(form){e.preventDefault();addToCart(form)}
  });
  document.querySelectorAll('[data-gallery]').forEach(g=>{
    const main=g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(t=>t.addEventListener('click',()=>{main.src=t.dataset.galleryThumb}));
  });
  document.querySelectorAll('[data-quantity]').forEach(box=>{
    const input=box.querySelector('input');
    box.querySelector('[data-minus]')?.addEventListener('click',()=>input.value=Math.max(1,parseInt(input.value||1)-1));
    box.querySelector('[data-plus]')?.addEventListener('click',()=>input.value=parseInt(input.value||1)+1);
  });
  document.querySelector('[data-mobile-toggle]')?.addEventListener('click',()=>{
    const nav=document.querySelector('[data-mobile-nav]'); if(nav) nav.hidden=!nav.hidden;
  });
})();
